import { render, staticRenderFns } from "./TemplateTheme.vue?vue&type=template&id=a7b9e6ce"
import script from "./TemplateTheme.vue?vue&type=script&lang=js"
export * from "./TemplateTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports